import React from "react";

const WhyChoose = () => {
  return (
    <div className="wcu-area-2 ">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="title-area text-center me-xl-4 ms-xl-4">
              <span className="sub-title">
                <img src="assets/img/icon/title_left.svg" alt="shape" />
                Why Choose B Plus Technology
              </span>
              <h2 className="sec-title style2">
                Government-Ready & Innovation-Focused Solutions
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-6">
            <div className="wcu-thumb">
              <div className="wcu-thumb-1">
                <img src="assets/img/normal/wcu-thumb-1-1.png" alt="img" />
              </div>
              <div className="wcu-shape jump">
                <img src="assets/img/normal/1.png" alt="img" />
              </div>
              <div className="wcu-shape2 movingX">
                <img src="assets/img/normal/2.png" alt="img" />
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="wcu-card-wrap">
              <div className="wcu-card">
                <div className="icon">
                  <img src="assets/img/icon/wcu-icon_2-1.svg" alt="img" />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">
                    Government-Ready Compliance Solutions
                  </h4>
                  <p className="wcu-card-text">
                    Secure, compliant, and scalable solutions designed specifically 
                    for government and public sector requirements.
                  </p>
                </div>
              </div>
              <div className="wcu-card">
                <div className="icon">
                  <img src="assets/img/icon/wcu-icon_2-2.svg" alt="img" />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">
                    AI & IT Integration Expertise
                  </h4>
                  <p className="wcu-card-text">
                    Comprehensive expertise in artificial intelligence, IT solutions, 
                    and hardware integration for seamless operations.
                  </p>
                </div>
              </div>
              <div className="wcu-card">
                <div className="icon">
                  <img src="assets/img/icon/wcu-icon_2-3.svg" alt="img" />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">
                    Scalable India-First Solutions
                  </h4>
                  <p className="wcu-card-text">
                    Scalable technology solutions designed for India-first initiatives 
                    and global expansion capabilities.
                  </p>
                </div>
              </div>
              <div className="wcu-card">
                <div className="icon">
                  <img src="assets/img/icon/wcu-icon_2-4.svg" alt="img" />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">Long-Term Partnership Commitment</h4>
                  <p className="wcu-card-text">
                    Dedicated to innovation, reliability, and building lasting partnerships 
                    with our clients and stakeholders.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChoose;
